import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=260f442a"
var script = {}
import style0 from "./introduction.vue?vue&type=style&index=0&id=260f442a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports